var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isAdditionalContent)?_c(_vm.component.instance,_vm._b({key:_vm.content.id,tag:"component"},'component',_vm.component.props,false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }